import axios from 'axios';


export const findimages = async (topic,num_results) => {
    if(topic === null){
        return []
    }

    const access_token = localStorage.getItem('access_token')
    if(access_token == null){
      return Promise.reject("unauthorized"); // Reject the promise with the error
    }


    try {
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}promptssuggestions/findimages?topic=${encodeURIComponent(topic)}&num_results=${num_results}`,
            {},
            {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${access_token}`,
                }
            }
        );

        return response.data;
    } catch (error) {
        return Promise.reject(error);
    }
};

export const findNewImages = async (query, studentType) => {

    if (!query) {
        return [];
    }

    try {
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}promptssuggestions/findnewimages`,
            {
                student_type: studentType,
                query: query
            },
            {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                }
            }
        );

        return response.data;

    } catch (error) {
        return Promise.reject(error);
    }
};